import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';

import firebase,{auth} from '../../firebase'
const NavBar = () => {
  return (
    <Navbar bg="dark" variant="dark" style={{fontFamily:"Poppins"}}>
      <Container>
        <Link to="/" className="navbar-brand">
          NNNChristianBale🦇
        </Link>
        <Nav className="me-auto">
          <Nav.Link as={Link} to="/">
            Calendar
          </Nav.Link>
          <Nav.Link as={Link} to="/leaderboard">
            Leaderboard
          </Nav.Link>
          <Nav.Link as={Link} to="/about">
            About
          </Nav.Link>
        </Nav>
        <Nav>
            <Nav.Link disabled style={{color:"white"}}>{auth.currentUser.displayName}</Nav.Link>
            <Button onClick={()=>{auth.signOut();window.location.reload()}}>Log Out</Button>
          </Nav>
      </Container>
    </Navbar>
  );
};

export default NavBar;
